import script from "./dispose-readonly-value.vue?vue&type=script&setup=true&lang=ts"
export * from "./dispose-readonly-value.vue?vue&type=script&setup=true&lang=ts"

import "./dispose-readonly-value.vue?vue&type=style&index=0&id=f211f4ca&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f211f4ca"]])

export default __exports__